import { errors } from './errorCodes.js';
/**
 * Add a problem for this nag list
 * @param nags The list to append this nag to
 * @param key The error message key
 * @param attributes Optional additional attributes
 */
export function nag(nags, key, attributes) {
    var data = {
        key: key,
        description: errors[key][0],
        isError: errors[key][1],
    };
    if (attributes) {
        data.attributes = attributes;
    }
    nags.push(data);
}
/**
 * Append a nag specific to a vCard or vCard line
 * @param nags The list to append this nag to
 * @param key The error message key
 * @param attr Specific information for this vCard
 */
export function nagVC(nags, key, attributes) {
    if (attributes.line) {
        // Shorten the potentially homunguous unwrapped lines (e.g. PHOTO)
        attributes.line = shorten(attributes.line);
    }
    nag(nags, key, attributes);
}
export var SHORTEN_TO = 30;
/**
 * Shortens a string to at most `MAX_DEBUG` chars (plus a trailing `…`, if it was shortened)
 * @param s String
 * @returns Potentially shortened string
 */
export function shorten(s, shortenTo) {
    if (shortenTo === void 0) { shortenTo = SHORTEN_TO; }
    if (s.length > SHORTEN_TO) {
        return s.substring(0, shortenTo - 1) + '…';
    }
    else {
        return s;
    }
}
//# sourceMappingURL=errors.js.map